import { useEffect } from "react";
import "./scroll.css"; // Add your CSS file

function Timeline() {
  useEffect(() => {
    // Add event listener to check scroll position
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const scrollToTopBtn = document.getElementById("scrollToTopBtn");

    // Show/hide the button based on scroll position
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      scrollToTopBtn.style.display = "block";
    } else {
      scrollToTopBtn.style.display = "none";
    }
  };

  const scrollToTop = () => {
    // Scroll to the top of the page
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };
  // const openWhatsApp = () => {
  //   // Replace '1234567890' with the actual WhatsApp number you want to open a chat with
  //   const phoneNumber = '1234567890';

  //   // Create the WhatsApp link
  //   const whatsappLink = `https://wa.me/${phoneNumber}`;

  //   // Open the WhatsApp link in a new tab
  //   window.open(whatsappLink, '_blank');
  // };

  return (
    <section>
      <div className="container">
        <div className="timeline-container">
          {/* <div className="whatsapp-button" onClick={() => openWhatsApp()}>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm-1.413 18.248c-.19.106-.65.282-1.482-.195-.843-.482-4.945-2.82-5.951-3.414-.425-.243-.656-.411-.87-.664-.211-.248-.324-.552-.365-.924-.055-.487.153-1.018.586-1.505.48-.514 1.14-.832 2.254-1.195 1.114-.362 1.92-.707 2.37-1.099.453-.394.646-.764.766-1.123.123-.375.143-.905.02-1.601-.134-.788-.482-1.573-1.05-2.36-.872-1.004-1.882-1.712-2.88-2.165-.77-.322-1.573-.483-2.355-.504-1.453-.04-2.853.34-4.148 1.035-1.76.88-3.213 2.468-3.775 4.475-.095.284-.262 1.04-.045 2.047.21 1.018.69 2.11 1.517 3.058.387.377.838.7 1.36.972.576.322 1.208.516 1.832.735.817.287 1.565.552 2.253.951.685.4 1.226.842 1.688 1.32.383.395.705.874.97 1.43.14.34.217.714.227 1.1.01.495-.072.97-.227 1.427-.265.688-.59 1.312-.972 1.884z" fill="#25D366"/>
  </svg>
</div> */}
          <button id="scrollToTopBtn" onClick={() => scrollToTop()} aria-label="Scroll to top">
            <svg
              width="16"
              height="20"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 10.5714L10.5 2M10.5 2L19 10.5714M10.5 2L10.5 22"
                stroke="#FBFBFB"
                strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Timeline;
